import React from "react";
import { SquareChevronLeft } from "lucide-react";

const pointsData = [
  {
    task: "Update your social media profiles: Instagram, Twitter, Facebook, LinkedIn",
    points: "50",
  },
  {
    task: 'Mention on LinkedIn profile: "Campus Ambassador at Aaruush\'26"',
    points: "20",
  },
  { task: "Follow AARUUSH social media handles", points: "40" },
  {
    task: "(CA)Registrations using Reference from the same college",
    points: "25",
  },
  {
    task: "(CA)Registrations using Reference from another college",
    points: "50",
  },
  { task: "Previous Year participants coming back (Loyalty)", points: "60" },
  { task: "Registrations for unpaid Events/Workshops", points: "40/reg" },
  { task: "Registrations for paid Events/Workshops", points: "70/reg" },
  { task: "Registrations for Common Registration", points: "75" },
  { task: "Social Media Drills", points: "T1.2" },
  { task: "Milestone Bonus Points", points: "T1.3" },
  { task: "Testimonial section", points: "50" },
  { task: "Weekly Questions", points: "20" },
  { task: "Rank Upgrade", points: "50" },
  { task: "Competitions", points: "1st(100), 2nd(75), 3rd(50)" },
  { task: "Top the Clan Leader board", points: "1st(100), 2nd(75), 3rd(50)" },
];

const rankData = [
  { title: "Cavalry", points: "499-1198" },
  { title: "Apprentice", points: "1199-1998" },
  { title: "Knight", points: "1999-2998" },
  { title: "Lord", points: "2999-3998" },
  { title: "King", points: "3999+" },
];

// const table12Data = [
//   { task: "Like + Share post on story", points: "5" },
//   { task: "Reel (10sec min)", points: "20" },
//   { task: "Post on Instagram (poster or reel)", points: "30" },
//   { task: "Post on LinkedIn", points: "40" },
//   { task: "Post on Twitter/X", points: "30" },
// ];

// const table13Data = [
//   { task: "100 Points", points: "+10" },
//   { task: "250 Points", points: "+20" },
//   { task: "500 Points", points: "+30" },
//   { task: "1000 Points", points: "+50" },
// ];

const Guideline = () => {
  return (
    <div className="min-h-screen bg-[#04051C] text-white px-4 py-12 flex flex-col items-center font-montserrat">
      <a href="/" className="absolute top-11 right-5 md:right-32 w-10">
        <SquareChevronLeft size={35} />
      </a>
      <h1 className="text-3xl md:text-7xl font-montserrat font-bold text-center mb-6 max-w-6xl w-full px-4 sm:px-6 md:px-10 z-0">
        GUIDELINES
      </h1>
      <div className="bg-[#0B0B2C] text-sm md:text-base  font-montserrat  text-left rounded-lg max-w-6xl w-full px-6 py-8 sm:py-10 md:px-10 mb-10 border-2 border-[#213E8C7D]">
        <p>
          The Campus Ambassadors will be assigned different ranks on the basis
          of their points. Rank system is only applicable to Campus Ambassadors
          with points more than 499, i.e. Campus Ambassadors eligible for
          participation certificate and other incentives. Campus Ambassadors can
          climb up the ranks by stacking points and obtaining +50 bonus points
          that comes along with rank upgrades. Campus Ambassadors will get
          sorted into 6 clans to effectively manage their workflow and to
          improve their interaction.
        </p>
      </div>

      <div className="bg-[#0B0B2C] rounded-lg max-w-6xl w-full px-6 py-8 border-2 border-[#213E8C7D] mb-12">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold">RANKERS</h2>
          <h2 className="text-2xl md:text-3xl font-bold">POINTS</h2>
        </div>
        <div className="flex flex-col gap-4">
          {rankData.map((rank, idx) => (
            <div key={idx} className="flex justify-between items-center gap-8">
              <div className="bg-[#213E8C7D] rounded-full px-8 py-2.5  font-montserrat text-base md:text-lg font-medium w-[200px] text-center">
                {rank.title}
              </div>
              <div className="bg-[#213E8C7D] rounded-full px-8 py-2.5  font-montserrat text-base md:text-lg font-medium w-[200px] text-center">
                {rank.points}
              </div>
            </div>
          ))}
        </div>
      </div>

      <h1 className="text-3xl md:text-4xl font-bold text-center mb-4  font-montserrat uppercase max-w-6xl w-full px-4 sm:px-6 md:px-10">
        Points Table
      </h1>
      <div className="bg-[#0B0B2C] rounded-lg max-w-6xl w-full px-6 py-3 mb-8 border-2 border-[#213E8C7D]">
        <p className="text-sm md:text-base font-montserrat ">
          The Campus Ambassadors will gain points based on the following
          criteria:
        </p>
      </div>

      <div className="bg-[#0B0B2C] rounded-lg max-w-6xl w-full px-6 py-10 md:px-10 shadow-lg mb-16 border-2 border-[#213E8C7D]">
        <div className="flex justify-between mb-10 border-b border-white pb-4">
          <h2 className="text-xl font-semibold uppercase font-montserrat ">Tasks</h2>
          <h2 className="text-xl font-semibold uppercase font-montserrat ">Points</h2>
        </div>

        <div className="flex flex-col gap-4">
          {pointsData.map((entry, index) => {
            const isRankingEntry =
              entry.points.includes("1st") &&
              entry.points.includes("2nd") &&
              entry.points.includes("3rd");

            if (isRankingEntry) {
              const rankings = [
                { rank: "1st", points: "100" },
                { rank: "2nd", points: "75" },
                { rank: "3rd", points: "50" },
              ];

              return (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row justify-between items-center gap-4 w-full"
                >
                  <div className="bg-[#213E8C7D] font-montserrat  px-6 py-3 rounded-xl text-sm md:text-base font-medium w-full sm:w-[60%] text-center sm:text-left">
                    {entry.task}
                  </div>
                  <div className="flex justify-end gap-4 w-full sm:w-[40%]">
                    {rankings.map((rank, i) => (
                      <div
                        key={i}
                        className="bg-[#213E8C7D] font-montserrat  px-4 py-3 rounded-xl text-sm md:text-base font-medium w-[100px] text-center"
                      >
                        {rank.rank}: {rank.points}
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            return (
              <div
                key={index}
                className="flex flex-col sm:flex-row justify-between items-center gap-4 w-full"
              >
                <div className="bg-[#213E8C7D] font-montserrat  px-6 py-3 rounded-xl text-sm md:text-base font-medium w-full sm:w-[60%] text-center sm:text-left">
                  {entry.task}
                </div>
                <div className="bg-[#213E8C7D] font-montserrat  px-6 py-3 rounded-xl text-sm md:text-base font-medium w-full sm:w-[100px] text-center">
                  {entry.points}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Table 1.2 Heading */}
      <h2 className="text-2xl md:text-4xl font-montserrat font-bold text-center mb-8">
        Table 1.2
      </h2>

      {/* Social Media Points Grid - Table 1.2 */}
      <div className="bg-[#0B0B2C] rounded-lg max-w-6xl w-full px-6 py-10 md:px-10 shadow-lg mb-16 border-2 border-[#213E8C7D]">
        {/* Grid Headers */}
        <div className="grid grid-cols-5 gap-4 mb-6 font-montserrat  text-center text-sm md:text-base font-bold uppercase">
          <div className="col-span-1">Category</div>
          <div>Flagship Events</div>
          <div>Workshops</div>
          <div>Championships</div>
          <div>Points</div>
        </div>

        {/* Grid Content */}
        <div className="flex flex-col gap-4 font-montserrat ">
          {/* Instagram */}
          <div className="grid grid-cols-5 gap-4 items-center">
            <div className="col-span-1 bg-[#213E8C7D] rounded-xl px-4 py-3 text-sm md:text-base">
              <div className="font-semibold">Instagram</div>
              <div className="text-xs opacity-75">
                1.See 2.Comment 3.Share 4.Like
              </div>
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              15
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              15
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              15
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              15
            </div>
          </div>

          {/* WhatsApp */}
          <div className="grid grid-cols-5 gap-4 items-center">
            <div className="col-span-1 bg-[#213E8C7D] rounded-xl px-4 py-3 text-sm md:text-base">
              <div className="font-semibold">WhatsApp</div>
              <div className="text-xs opacity-75">
                1.Share 2.Forward to minimum 2 friends
              </div>
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
          </div>

          {/* Facebook */}
          <div className="grid grid-cols-5 gap-4 items-center">
            <div className="col-span-1 bg-[#213E8C7D] rounded-xl px-4 py-3 text-sm md:text-base">
              <div className="font-semibold">Facebook</div>
              <div className="text-xs opacity-75">1.Like 2.Share</div>
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
          </div>

          {/* LinkedIn */}
          <div className="grid grid-cols-5 gap-4 items-center">
            <div className="col-span-1 bg-[#213E8C7D] rounded-xl px-4 py-3 text-sm md:text-base">
              <div className="font-semibold">LinkedIn</div>
              <div className="text-xs opacity-75">1.Like 2.Share 3.Comment</div>
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              15
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              15
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              15
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              15
            </div>
          </div>

          {/* Twitter */}
          <div className="grid grid-cols-5 gap-4 items-center">
            <div className="col-span-1 bg-[#213E8C7D] rounded-xl px-4 py-3 text-sm md:text-base">
              <div className="font-semibold">Twitter</div>
              <div className="text-xs opacity-75">
                1.Retweet 2.Like 3.Comment
              </div>
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
            <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base mx-auto">
              10
            </div>
          </div>
        </div>
      </div>

      {/* Table 1.3 Heading */}
      <h2 className="text-2xl md:text-4xl font-montserrat  font-bold text-center mb-8">
        Table 1.3
      </h2>

      {/* Table 1.3 - Total Registration Points */}
      <div className="bg-[#0B0B2C] rounded-lg max-w-6xl w-full px-6 py-10 md:px-10 shadow-lg mb-12 border-2 border-[#213E8C7D]">
        {/* Headers */}
        <div className="grid grid-cols-2 gap-6 mb-6 text-center text-lg md:text-xl font-semibold">
          <div>TOTAL REGISTRATION</div>
          <div>POINTS</div>
        </div>

        {/* Registration Points Grid */}
        <div className="flex flex-col gap-4 max-w-3xl mx-auto">
          {[
            { registration: "25", points: "50" },
            { registration: "50", points: "100" },
            { registration: "100", points: "150" },
            { registration: "150", points: "200" },
            { registration: "200", points: "25" },
          ].map((item, idx) => (
            <div key={idx} className="flex items-center gap-6">
              <div className="flex-1">
                <div className="bg-[#213E8C7D] rounded-xl py-3 px-6 text-center text-sm md:text-base w-full">
                  {item.registration}
                </div>
              </div>
              <div className="flex-1 flex justify-center">
                <div className="bg-[#213E8C7D] rounded-full w-12 h-12 flex items-center justify-center text-sm md:text-base">
                  {item.points}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Guideline;
